import { render, staticRenderFns } from "./FamilyPhaseEditor.vue?vue&type=template&id=b49488a6&scoped=true&"
import script from "./FamilyPhaseEditor.vue?vue&type=script&lang=js&"
export * from "./FamilyPhaseEditor.vue?vue&type=script&lang=js&"
import style0 from "./FamilyPhaseEditor.vue?vue&type=style&index=0&id=b49488a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49488a6",
  null
  
)

export default component.exports